package fyi.moko.hotpl.ui.map

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import fyi.moko.hotpl.data.location.CurrentLocationProvider
import fyi.moko.hotpl.domain.model.GeoPoint
import fyi.moko.hotpl.ui.home.rememberLocationPermissionRequest
import org.koin.compose.koinInject

data class UserLocationState(
    val granted: Boolean = false,
    val target: GeoPoint? = null,
    /** How old the fix behind [target] is, when the platform can say. */
    val fixAgeMillis: Long? = null,
)

/**
 * Requests location permission (once) and resolves the device's last known location
 * via the shared [CurrentLocationProvider] / [rememberLocationPermissionRequest]
 * abstractions. Used to center maps on the user's area instead of a hard-coded
 * fallback. Pure common code — works the same on Android and iOS.
 */
@Composable
fun rememberUserLocation(): UserLocationState {
    val provider = koinInject<CurrentLocationProvider>()
    var state by remember { mutableStateOf(UserLocationState(granted = provider.isPermissionGranted())) }

    val requester = rememberLocationPermissionRequest { granted ->
        state = state.copy(granted = granted)
    }

    LaunchedEffect(Unit) {
        if (!provider.isPermissionGranted()) requester.launch()
    }

    LaunchedEffect(state.granted) {
        if (state.granted && state.target == null) {
            val fix = provider.lastKnownFix()
            if (fix != null) {
                state = state.copy(target = fix.point, fixAgeMillis = fix.ageMillis)
            }
        }
    }

    return state
}